import {
  BarsOutlined,
  SoundOutlined,
  ShoppingCartOutlined,
  FolderOpenOutlined,
  ApartmentOutlined,
  DashboardOutlined,
  FileImageOutlined,
  SettingOutlined,
  FileSearchOutlined,
  SecurityScanOutlined,
  CalendarOutlined,
  ScheduleOutlined,
  PayCircleOutlined,
  BookOutlined,
  CheckCircleOutlined,
  PlusCircleFilled,
  // MenuOutlined,
  AlignLeftOutlined,
  ShopOutlined,
  TeamOutlined,
  LikeOutlined,
  ProjectFilled,
  ForkOutlined,
  ApiOutlined,
  BankOutlined,
  KeyOutlined,
  BarChartOutlined,
  GlobalOutlined,
  // AppstoreAddOutlined,
  SkinOutlined,
  QrcodeOutlined,
  LineChartOutlined,
  BulbOutlined,
  HistoryOutlined,
  SwapOutlined,
  // DatabaseOutlined,
  // LockOutlined,
} from "@ant-design/icons";
import assets from "../utils/ImagesPath";

// ==================== CONST DATA START ==================== //

// Project Info
export const DEMO_MODE = false;
export const PROJECT_NAME = "HotelNXT Booking Software";
export const CREATOR_NAME = "HotelNXT";
export const CREATOR_LINK = "https://www.hotelnxt.com";
export const CURRENCY = "₹";
export const STATIC_VIDEO_LINK =
  "https://storage.hotelnxt.com/hotel/hotel-video/217490_small.mp4";
// Theme
export const THEME = "d9534f";
export const SECONDARY_THEME = "3f37c9";
export const INV_THEME = "e2ecee";
export const RADIUS = "30px";

// Pusher use for notification
export const PUSHER_APP_CLUSTER = "ap2";
// ==================== CONST DATA END ==================== //

export const DRAWER_MENU = [
  {
    category: "Dashboard",
    icon: <DashboardOutlined />,
    items: [
      {
        key: "dashboard",
        icon: <DashboardOutlined />,
        label: "Dashboard",
        to: "/",
      },
    ],
  },
  {
    category: "Channel Manager",
    icon: <ApiOutlined />,
    items: [
      {
        key: "rate_plan",
        icon: <ProjectFilled />,
        label: "Rate Plan",
        to: "/ota-rate-plan",
      },
      {
        key: "external_logs",
        icon: <ForkOutlined />,
        label: "External Logs",
        to: "/external-logs",
      },
    ],
  },
  {
    category: "PMS",
    icon: <BankOutlined />,
    items: [
      {
        key: "all_calendar_v2",
        icon: <CalendarOutlined />,
        label: "Stay View",
        to: "/stay-view",
      },
      {
        key: "rooms_view",
        icon: <ShopOutlined />,
        label: "Rooms View",
        to: "/room-view",
      },
      {
        key: "qr_pass_scanner",
        icon: <QrcodeOutlined />,
        label: "QR Pass Scanner",
        to: "/scan",
      },
      {
        key: "reservation_data",
        icon: <AlignLeftOutlined />,
        label: "Reservations Data",
        to: "/reservation-data",
      },
      {
        key: "reservation_add",
        icon: <PlusCircleFilled />,
        label: "Reservation",
        to: "/booking-reservation",
      },
      {
        key: "guests",
        icon: <TeamOutlined />,
        label: "Guests",
        to: "/guests",
      },
    ],
  },
  {
    category: "PMS - Bookings & Reservations",
    icon: <CalendarOutlined />,
    items: [
      // {
      //   key: "all_calendar",
      //   icon: <CalendarOutlined />,
      //   label: "Booking Calendar",
      //   to: "/booking-calendar",
      // },
      // {
      //   key: "all_calendar_v2",
      //   icon: <CalendarOutlined />,
      //   label: "Booking Calendar V2",
      //   to: "/stay-view",
      // },
      {
        key: "all_bookings",
        icon: <ShoppingCartOutlined />,
        label: "All Bookings",
        to: "/booking?type=all",
      },
      {
        key: "completed_invoice",
        icon: <BookOutlined />,
        label: "Completed Invoice",
        to: "/booking/invoice",
      },
      {
        key: "completed_checkin",
        icon: <CheckCircleOutlined />,
        label: "Completed Booking",
        to: "/booking?type=completed_checkin",
      },
      {
        key: "completed_multi_booking",
        icon: <CheckCircleOutlined />,
        label: "Completed Multi Booking",
        to: "/booking?type=multi_booking",
      },
      {
        key: "pending_checkin",
        icon: <CalendarOutlined />,
        label: "Pending Check-In",
        to: "/booking?type=pending_checkin",
      },
      {
        key: "delayed_checkin",
        icon: <PayCircleOutlined />,
        label: "Delayed Check-In",
        to: "/booking?type=delayed_checkin",
      },
      {
        key: "upcoming_checkin",
        icon: <ScheduleOutlined />,
        label: "Upcoming Check-In",
        to: "/booking?type=upcoming_checkin",
      },
      {
        key: "upcoming_checkout",
        icon: <CheckCircleOutlined />,
        label: "Upcoming Checkout",
        to: "/booking?type=upcoming_checkout",
      },
      {
        key: "delayed_checkout",
        icon: <PayCircleOutlined />,
        label: "Delayed Checkout",
        to: "/booking?type=delayed_checkout",
      },
      {
        key: "active_bookings",
        icon: <BookOutlined />,
        label: "Active Bookings",
        to: "/booking?type=active",
      },
      // {
      //   key: "reservation",
      //   icon: <PlusCircleFilled />,
      //   label: "Reservation",
      //   to: "/booking-reservation",
      // },
    ],
  },
  {
    category: "PMS - Orders & Communication",
    icon: <ShoppingCartOutlined />,
    items: [
      {
        key: "orders",
        icon: <ShoppingCartOutlined />,
        label: "Guest Orders",
        to: "/order",
      },
      {
        key: "contacts",
        icon: <ShoppingCartOutlined />,
        label: "Enquiries / Contacts",
        to: "/contacts",
      },
    ],
  },
  {
    category: "RMS - Rooms & Facilities",
    icon: <KeyOutlined />,
    items: [
      {
        key: "facility",
        icon: <ApartmentOutlined />,
        label: "Facilities",
        to: "/facility",
      },
      { key: "rooms", icon: <SoundOutlined />, label: "Rooms", to: "/room" },
      {
        key: "service",
        icon: <SoundOutlined />,
        label: "Services",
        to: "/service",
      },
    ],
  },
  {
    category: "RMS - Staff & Customers",
    icon: <TeamOutlined />,
    items: [
      {
        key: "customer",
        icon: <TeamOutlined />,
        label: "Customers",
        to: "/customer",
      },
      {
        key: "staff",
        icon: <TeamOutlined />,
        label: "Staff Users",
        to: "/user",
      },
    ],
  },
  {
    category: "Laundry Management",
    icon: <SkinOutlined />,
    items: [
      {
        key: "laundry_vendor",
        icon: <TeamOutlined />,
        label: "Vendors",
        to: "/laundry/vendor",
      },
      {
        key: "laundry_item",
        icon: <BarsOutlined />,
        label: "Items",
        to: "/laundry/item",
      },
      {
        key: "laundry_stock_adjust",
        icon: <BarsOutlined />,
        label: "Stock Adjustment",
        to: "/laundry/stock-adjust",
      },
      {
        key: "laundry_out",
        icon: <ShoppingCartOutlined />,
        label: "Laundry Out",
        to: "/laundry/out",
      },
      {
        key: "laundry_payment",
        icon: <PayCircleOutlined />,
        label: "Payments",
        to: "/laundry/payment",
      },
      {
        key: "laundry_report_outstanding",
        icon: <FileSearchOutlined />,
        label: "Outstanding Report",
        to: "/laundry/report/outstanding",
      },
      {
        key: "laundry_report_ledger",
        icon: <FileSearchOutlined />,
        label: "Vendor Ledger",
        to: "/laundry/report/ledger",
      },
      {
        key: "laundry_report_out",
        icon: <FileSearchOutlined />,
        label: "Laundry Out Report",
        to: "/laundry/report/laundry-out",
      },
      {
        key: "laundry_stock",
        icon: <BarsOutlined />,
        label: "Stock Report",
        to: "/laundry/stock",
      },
      {
        key: "laundry_stock_ledger",
        icon: <BarsOutlined />,
        label: "Stock Ledger",
        to: "/laundry/stock-ledger",
      },
    ],
  },
  {
    category: "Kitchen Management",
    icon: <ShopOutlined />,
    items: [
      {
        key: "kitchen_item",
        icon: <BarsOutlined />,
        label: "Items",
        to: "/kitchen/item",
      },
      {
        key: "kitchen_purchase_request",
        icon: <ShoppingCartOutlined />,
        label: "Store Purchase Request",
        to: "/kitchen/purchase-request",
      },
      {
        key: "kitchen_purchase",
        icon: <ShoppingCartOutlined />,
        label: "Store Purchases",
        to: "/kitchen/purchase",
      },
      {
        key: "kitchen_purchase_return",
        icon: <ShoppingCartOutlined />,
        label: "Store Purchase Return",
        to: "/kitchen/purchase-return",
      },
      {
        key: "kitchen_issue",
        icon: <ForkOutlined />,
        label: "Item Issue",
        to: "/kitchen/issue",
      },
      {
        key: "kitchen_issue_inventory",
        icon: <ForkOutlined />,
        label: "Kitchen Issues Inventory",
        to: "/kitchen/issue/inventory",
      },

      {
        key: "kitchen_issue_remaining",
        icon: <ForkOutlined />,
        label: "Kitchen Remaining Manage",
        to: "/kitchen/issue/remaining",
      },
      {
        key: "kitchen_report_stock",
        icon: <BarChartOutlined />,
        label: "Stock Report",
        to: "/kitchen/report/stock",
      },
      {
        key: "kitchen_report_low_stock",
        icon: <BarChartOutlined />,
        label: "Low Stock Alert",
        to: "/kitchen/report/low-stock",
      },
      {
        key: "kitchen_report_exp_stock",
        icon: <BarChartOutlined />,
        label: "Expiry Stock Alert",
        to: "/kitchen/report/exp-stock",
      },
      {
        key: "kitchen_report_purchase_request",
        icon: <BarChartOutlined />,
        label: "Purchases Request Report",
        to: "/kitchen/report/purchase-request",
      },
      {
        key: "kitchen_report_purchase",
        icon: <BarChartOutlined />,
        label: "Purchase Report",
        to: "/kitchen/report/purchase",
      },
      {
        key: "kitchen_report_issue",
        icon: <BarChartOutlined />,
        label: "Issue / Consumption Report",
        to: "/kitchen/report/issue",
      },
      {
        key: "kitchen_report_daily_stock",
        icon: <BarChartOutlined />,
        label: "Daily Stock Report",
        to: "/kitchen/report/daily-stock",
      },
    ],
  },
  {
    category: "Smart Pricing",
    icon: <LineChartOutlined />,
    items: [
      {
        key: "smart_price_dashboard",
        icon: <DashboardOutlined />,
        label: "Smart Pricing Dashboard",
        to: "/smart-price",
      },
      {
        key: "smart_price_suggestions",
        icon: <BulbOutlined />,
        label: "Suggestions",
        to: "/smart-price/suggestions",
      },
      {
        key: "smart_price_generation_history",
        icon: <HistoryOutlined />,
        label: "Generation History",
        to: "/smart-price/generation-history",
      },
      {
        key: "smart_price_change_history",
        icon: <SwapOutlined />,
        label: "Change History",
        to: "/smart-price/change-history",
      },
      {
        key: "smart_price_calendar",
        icon: <CalendarOutlined />,
        label: "Demand Calendar",
        to: "/smart-price/calendar",
      },
      {
        key: "smart_price_pricing_rules",
        icon: <CalendarOutlined />,
        label: "Pricing Rules",
        to: "/smart-price/pricing-rules",
      },
      {
        key: "smart_price_festivals",
        icon: <CalendarOutlined />,
        label: "Festivals",
        to: "/smart-price/festivals",
      },
      
    ],
  },

  {
    category: "Reports",
    icon: <BarChartOutlined />,
    items: [
      {
        key: "reports",
        icon: <SecurityScanOutlined />,
        label: "Analytic Reports",
        to: "/reports",
      },
      {
        key: "reports_v2",
        icon: <SecurityScanOutlined />,
        label: "Analytic Reports V2",
        to: "/reports-v2",
      },
      {
        key: "booking_report",
        icon: <SecurityScanOutlined />,
        label: "Booking Reports",
        to: "/booking-reports",
      },
      {
        key: "night_audit",
        icon: <SecurityScanOutlined />,
        label: "Night Audit",
        to: "/night-audit",
      },
    ],
  },
  {
    category: "WEBSITE - Media & Pages",
    icon: <GlobalOutlined />,
    items: [
      {
        key: "file-manager",
        icon: <FolderOpenOutlined />,
        label: "File Manager",
        to: "/file-manager",
      },
      {
        key: "gallery",
        icon: <FileImageOutlined />,
        label: "Gallery",
        to: "/gallery",
      },
      {
        key: "slider",
        icon: <FileImageOutlined />,
        label: "Homepage Slider",
        to: "/slider",
      },
      {
        key: "team",
        icon: <TeamOutlined />,
        label: "Team Members",
        to: "/team",
      },
      {
        key: "testimonial",
        icon: <LikeOutlined />,
        label: "Testimonials",
        to: "/testimonial",
      },
      {
        key: "category",
        icon: <BarsOutlined />,
        label: "Categories",
        to: "/category",
      },
      {
        key: "product",
        icon: <ShoppingCartOutlined />,
        label: "Products",
        to: "/product",
      },
      {
        key: "blog",
        icon: <BarsOutlined />,
        label: "Blog / News",
        to: "/blog",
      },
    ],
  },
  {
    category: "System Settings",
    icon: <SettingOutlined />,
    items: [
      {
        key: "pages-seo",
        icon: <SecurityScanOutlined />,
        label: "SEO Settings",
        to: "/pages-seo",
      },
      {
        key: "dynamic-content",
        icon: <FileSearchOutlined />,
        label: "Dynamic Pages",
        to: "/pages",
      },
      {
        key: "setting",
        icon: <SettingOutlined />,
        label: "Global Settings",
        to: "/setting",
      },
      {
        key: "profile",
        icon: <SettingOutlined />,
        label: "My Profile",
        to: "/profile/update",
      },
      // {
      //   key: "db_manager",
      //   icon: <DatabaseOutlined />,
      //   label: "DB Manager",
      //   to: "/db-manage",
      // },
    ],
  },
];

// Role-wise access control
export const USER_ACCESS = {
  superAdmin: "all",
  admin: [
    "dashboard",
    "rate_plan",
    // "external_logs",
    "all_calendar_v2",
    "rooms_view",
    "reservation_data",
    "reservation_add",
    "guests",
    "all_bookings",
    "completed_checkin",
    "completed_multi_booking",
    "pending_checkin",
    "delayed_checkin",
    "upcoming_checkin",
    "upcoming_checkout",
    "delayed_checkout",
    "active_bookings",
    "reservation",
    "orders",
    "contacts",
    "facility",
    "rooms",
    "service",
    "customer",
    "staff",
    "reports",
    "reports_v2",
    "booking_report",
    "night_audit",
    "file-manager",
    "gallery",
    "slider",
    "team",
    "testimonial",
    "product",
    "blog",
    "dynamic-content",
    "profile",
    "laundry_vendor",
    "laundry_item",
    "laundry_stock_adjust",
    "laundry_out",
    "laundry_payment",
    "laundry_report_outstanding",
    "laundry_report_ledger",
    "laundry_report_out",
    "laundry_stock",
    "laundry_stock_ledger",
    "kitchen_item",
    "kitchen_purchase_request",
    "kitchen_purchase",
    "kitchen_purchase_return",
    "kitchen_issue",
    "kitchen_issue_inventory",
    "kitchen_issue_remaining",
    "kitchen_report_stock",
    "kitchen_report_low_stock",
    "kitchen_report_exp_stock",
    "kitchen_report_purchase_request",
    "kitchen_report_purchase",
    "kitchen_report_issue",
    "kitchen_report_daily_stock",
  ],
  reception: [
    "dashboard",
    // "all_calendar",
    "all_calendar_v2",
    "rooms_view",
    "reservation_data",
    "reservation_add",
    "guests",
    "all_bookings",
    "completed_checkin",
    "completed_multi_booking",
    "pending_checkin",
    // "reservation",
    "active_bookings",
    "upcoming_checkin",
    "upcoming_checkout",
    "delayed_checkin",
    "delayed_checkout",
    "orders",
    "contacts",
    // "customer",
    // "pages-seo",
    "profile",
  ],
  laundry: [
    "laundry_vendor",
    "laundry_item",
    "laundry_stock_adjust",
    "laundry_out",
    "laundry_payment",
    "laundry_report_outstanding",
    "laundry_report_ledger",
    "laundry_report_out",
    "laundry_stock",
    "laundry_stock_ledger",
    "profile",
  ],
  kitchen: ["orders", "profile"],
  kitchen_store_manager: [
    "kitchen_item",
    "kitchen_purchase_request",
    "kitchen_purchase",
    "kitchen_purchase_return",
    "kitchen_issue",
    "kitchen_issue_inventory",
    "kitchen_issue_remaining",
    "kitchen_report_stock",
    "kitchen_report_low_stock",
    "kitchen_report_exp_stock",
    "kitchen_report_purchase_request",
    "kitchen_report_purchase",
    "kitchen_report_issue",
    "kitchen_report_daily_stock",
    "profile",
  ],
  kitchen_stock_manager: [
    "kitchen_issue_inventory",
    "kitchen_issue_remaining",
    "kitchen_report_issue",
    "profile",
  ],
  biller: [
    "dashboard",
    "all_bookings",
    "active_bookings",
    "delayed_checkout",
    "orders",
    "reports",
    "reports_v2",
    "booking_report",
    "night_audit",
    "profile",
  ],
  accountant: [
    "reservation_add",
    "guests",
    "all_bookings",
    "profile",
    "laundry_payment",
    "laundry_report_outstanding",
    "laundry_report_ledger",
    "laundry_report_out",
    "laundry_stock",
    "laundry_stock_ledger",
  ],
  webAdmin: [
    "pages-seo",
    "orders",
    "file-manager",
    "gallery",
    "slider",
    "team",
    "testimonial",
    "category",
    "product",
    "blog",
    "profile",
  ],
};

export const PAYMENT_METHOD = [
  { value: "cash", label: "Cash" },
  { value: "razorpay", label: "Razorpay" },
  { value: "online_qr", label: "Online QR" },
  { value: "credit_card", label: "Credit Card" },
  { value: "bill_to_company", label: "Bill to Company" },
  { value: "wallet", label: "Wallet" },
  { value: "prepaid", label: "Prepaid" },
  { value: "bank_transfer", label: "Bank Transfer" },
  // Additional common payment methods
  { value: "upi", label: "UPI" },
  { value: "debit_card", label: "Debit Card" },
  { value: "net_banking", label: "Net Banking" },
  { value: "paypal", label: "PayPal" },
  { value: "stripe", label: "Stripe" },
  { value: "google_pay", label: "Google Pay" },
  { value: "phonepe", label: "PhonePe" },
  { value: "amazon_pay", label: "Amazon Pay" },
  { value: "apple_pay", label: "Apple Pay" },
  { value: "cheque", label: "Cheque" },
  { value: "emi", label: "EMI" },
];

export const ROOM_CAPACITY_TYPES = [
  { value: "S", label: "Single", capacity: 1 },
  { value: "D", label: "Double", capacity: 2 },
  { value: "T", label: "Triple", capacity: 3 },
  { value: "Q", label: "Quad", capacity: 4 },
  { value: "P", label: "Quint", capacity: 5 },
  { value: "H", label: "Hextuple", capacity: 6 },
  { value: "HP", label: "Heptuple", capacity: 7 },
  { value: "O", label: "Octuple", capacity: 8 },
  { value: "N", label: "Nonuple", capacity: 9 },
  { value: "DE", label: "Decuple", capacity: 10 },
  { value: "EL", label: "Eleven", capacity: 11 },
  { value: "TW", label: "Twelve", capacity: 12 },
  { value: "TH", label: "Thirteen", capacity: 13 },
  { value: "FO", label: "Fourteen", capacity: 14 },
  { value: "FI", label: "Fifteen", capacity: 15 },
  { value: "SI", label: "Sixteen", capacity: 16 },
  { value: "SE", label: "Seventeen", capacity: 17 },
  { value: "EI", label: "Eighteen", capacity: 18 },
  { value: "NI", label: "Nineteen", capacity: 19 },
  { value: "TWE", label: "Twenty", capacity: 20 },
];

export const OTA_SERVICE_TYPE = [
  {
    value: "ep",
    label: "EP (Room Only)",
    description: "EP: Room only, no meals included.",
  },
  {
    value: "cp",
    label: "CP (Room with Breakfast)",
    description: "CP: Room with breakfast included.",
  },
  {
    value: "map",
    label: "MAP (Room with Breakfast & Lunch or Dinner)",
    description:
      "MAP: Room with breakfast and either lunch or dinner included.",
  },
  {
    value: "ap",
    label: "AP (Room with Breakfast, Lunch & Dinner)",
    description: "AP: Room with breakfast, lunch, and dinner included.",
  },
];

export const DYNAMIC_PAGE_TYPE = [
  {
    value: "term",
    label: "Terms and Conditions",
  },
  {
    value: "privacy",
    label: "Privacy Policy",
  },
  {
    value: "refund",
    label: "Refund Policy",
  },
  {
    value: "about",
    label: "About Us-Section",
  },
  {
    value: "home_about",
    label: "Home About Us-Section",
  },
  {
    value: "room_cancellation_policy",
    label: "Room Cancellation Policy",
  },
  {
    value: "faq",
    label: "FAQ",
  },
  {
    value: "contact",
    label: "Contact Us",
  },
  {
    value: "support",
    label: "Support",
  },
  {
    value: "shipping",
    label: "Shipping Policy",
  },
  {
    value: "cancellation",
    label: "Cancellation Policy",
  },
  {
    value: "cookies",
    label: "Cookie Policy",
  },
  {
    value: "disclaimer",
    label: "Disclaimer",
  },
];

export const USER_TYPE = [
  {
    value: "superAdmin",
    label: "Super Admin",
  },
  {
    value: "admin",
    label: "Admin",
  },
  {
    value: "webAdmin",
    label: "Web Admin",
  },
  {
    value: "reception",
    label: "Reception",
  },
  {
    value: "kitchen",
    label: "Kitchen Restaurant",
  },
  {
    value: "laundry",
    label: "Laundry",
  },
  {
    value: "biller",
    label: "Biller",
  },
  {
    value: "accountant",
    label: "Accountant",
  },

  {
    value: "kitchen_store_manager",
    label: "Kitchen Store Manager (KM)",
  },
  {
    value: "kitchen_stock_manager",
    label: "Kitchen Stock Manager (KM)",
  },
];

export const BUSINESS_SEGMENT = [
  {
    value: "walk-in",
    label: "Walk-In",
  },
  {
    value: "corporate",
    label: "Corporate",
  },
  {
    value: "ota",
    label: "OTA",
  },
  {
    value: "travel-agent",
    label: "Travel Agent",
  },
  {
    value: "booking-engine",
    label: "Booking Engine",
  },
  {
    value: "others",
    label: "Others",
  },
];

export const BUSINESS_SEGMENT_IMG = {
  portal: assets.walkIn,
  "booking-engine": assets.booking_engine,
  corporate: assets.corporate,
  "travel-agent": assets.travel_agency,
  agoda: assets.agoda,
  "booking.com": assets.bookingcom,
  makemytrip: assets.makemytrip,
  "a-expedia": assets.expedia,
  expedia: assets.expedia,
  goibibo: assets.goibibo,
  airbnb: assets.airbnb,
  ota: assets.ota,
  others: assets.others,
};

export const PAGES_TYPE = [
  {
    value: "home",
    label: "Home",
  },
  {
    value: "about",
    label: "About",
  },
  {
    value: "room",
    label: "Room",
  },
  {
    value: "room-detail",
    label: "Room Detail",
  },
  {
    value: "facilities",
    label: "Facilities",
  },
  {
    value: "gallery",
    label: "Gallery",
  },
  {
    value: "news",
    label: "News",
  },
  {
    value: "news-detail",
    label: "News Detail",
  },
  {
    value: "contact",
    label: "Contact",
  },
  {
    value: "room-reservation",
    label: "Room Reservation",
  },
];

export const ITEM_UNITS = [
  { label: "Kg", value: "Kg" },
  { label: "Gram", value: "Gram" },

  { label: "Ltr", value: "Ltr" },
  { label: "Ml", value: "Ml" },

  { label: "Pcs", value: "Pcs" },
  { label: "Dozen", value: "Dozen" },

  { label: "Pack", value: "Pack" },
  { label: "Box", value: "Box" },

  { label: "Bottle", value: "Bottle" },
  { label: "Can", value: "Can" },

  { label: "Bag", value: "Bag" },
  { label: "Sack", value: "Sack" },

  { label: "Tray", value: "Tray" },
  { label: "Strip", value: "Strip" },
];

export const ISSUE_DEPARTMENT = [
  { label: "Kitchen", value: "Kitchen" },
  { label: "Housekeeping", value: "Housekeeping" },
  { label: "Restaurant (F&B)", value: "Restaurant (F&B)" },
  { label: "Front Office", value: "Front Office" },
];

export const PASSCODE = "652577";

export const getMenuIcon = (key) => {
  for (const category of DRAWER_MENU) {
    const item = category.items.find((x) => x.key === key);

    if (item) {
      return item.icon;
    }
  }

  return null;
};

export const getBookingType = (info) => {
  const source = info.booking_source?.toLowerCase();
  const segment = info.booking_segment?.toLowerCase();

  return segment === "ota" ? source : segment;
};

// Function to get the label for a user_type value
export const getUserTypeLabel = (userType) => {
  // Find the matching user type in the USER_TYPE array
  const userTypeObj = USER_TYPE.find((type) => type.value === userType);

  // If a match is found, return the label, otherwise return a default value
  return userTypeObj ? userTypeObj.label : "Unknown User Type";
};

// Function to get the label for a page value
export const getPageTypeLabel = (pageType) => {
  // Find the matching user type in the PAGES_TYPE array
  const pageTypeObj = PAGES_TYPE.find((type) => type.value === pageType);

  // If a match is found, return the label, otherwise return a default value
  return pageTypeObj ? pageTypeObj.label : "Unknown Page Type";
};

export const getDyPageTypeLabel = (pageType) => {
  const pageTypeObj = DYNAMIC_PAGE_TYPE.find((type) => type.value === pageType);
  return pageTypeObj ? pageTypeObj.label : "Unknown Page Type";
};

// Function to get the label for a segment value
export const getSegmentLabel = (value) => {
  // Find the matching value in the BUSINESS_SEGMENT array
  const obj = BUSINESS_SEGMENT.find(
    (type) => type.value.toLowerCase() === value.toLowerCase(),
  );

  // If a match is found, return the label, otherwise return a default value
  return obj ? obj.label : "Unknown Type";
};

// Function to get the label for a service value
export const getServiceLabel = (value) => {
  // Find the matching user type in the OTA_SERVICE_TYPE array
  const serviceObj = OTA_SERVICE_TYPE.find((type) => type.value === value);

  // If a match is found, return the label, otherwise return a default value
  return serviceObj ? serviceObj.label : "Unknown Service Type";
};

// Function to get the label for a service value
export const getRoomTypeLabel = (value) => {
  const obj = ROOM_CAPACITY_TYPES.find((type) => type.value === value);
  return obj ? obj.label : "Unknown Type";
};

export const getRoomCapicityLabel = (value) => {
  const obj = ROOM_CAPACITY_TYPES.find((type) => type.value === value);
  return obj ? obj.capacity : 0;
};

export const getPayTypeLabel = (value) => {
  const obj = PAYMENT_METHOD.find((type) => type.value === value);
  return obj ? obj.label : value;
};

export const bookingStatusColors = {
  0: "#FFD700", // Pending - Yellow
  1: "#006400", // On Going - Green
  2: "#90EE90", // Completed - Light Green
  3: "#FF7F7F", // Cancelled - Light Red
  4: "#FFA500", // Accepted - Orange
};

export const bookingStatusText = {
  0: "Pending", // Pending - Yellow
  1: "On Going", // On Going - Green
  2: "Completed", // Completed - Light Green
  3: "Cancelled", // Cancelled - Light Red
  4: "Accepted", // Accepted - Orange
};

export const getInclusiveGstRateAndAmount = (totalPrice, totalDays = 1) => {
  let gstRate = 0;

  if (totalPrice < 1000) {
    gstRate = 5;
  } else if (totalPrice <= 7500) {
    gstRate = 5;
  } else {
    gstRate = 18;
  }

  const grandTotal = totalPrice * totalDays;
  const baseAmount = grandTotal / (1 + gstRate / 100);
  const gstAmount = grandTotal - baseAmount;

  return {
    gstRate,
    baseAmount: Number(baseAmount.toFixed(2)),
    gstAmount: Number(gstAmount.toFixed(2)),
    totalAmount: Number(grandTotal.toFixed(2)),
  };
};

export const getGstRateAndAmount = (roomPrice, totalDays = 1) => {
  let gstRate = 0;

  if (roomPrice < 1000) {
    gstRate = 5;
  } else if (roomPrice <= 7500) {
    gstRate = 5;
  } else {
    gstRate = 18;
  }

  const baseAmount = roomPrice * totalDays;
  const gstAmount = (baseAmount * gstRate) / 100;

  return {
    gstRate,
    gstAmount: Number(gstAmount.toFixed(2)),
  };
};

export const getGstRate = (roomPrice) => {
  if (roomPrice < 1000) {
    return 5;
  } else if (roomPrice <= 7500) {
    return 5;
  } else {
    return 18;
  }
};

export const calculateBillAmountWithGST = (
  roomPrice,
  totalDays,
  advanceAmount = 0,
) => {
  const gstRate = getGstRate(roomPrice);

  const baseAmount = roomPrice * totalDays;
  const gstAmount = (baseAmount * gstRate) / 100;
  const totalWithGst = baseAmount + gstAmount;
  const billAmount = totalWithGst - advanceAmount;

  return {
    roomPrice: Number(roomPrice.toFixed(2)),
    totalDays,
    gstRate,
    baseAmount: Number(baseAmount.toFixed(2)),
    gstAmount: Number(gstAmount.toFixed(2)),
    totalWithGst: Number(totalWithGst.toFixed(2)),
    advance: Number(advanceAmount.toFixed(2)),
    billAmount: Number(billAmount.toFixed(2)),
  };
};

export const calculateTotalBill = (
  selected_rooms_ids,
  all_rooms_info,
  totalDays,
  advanceAmount = 0,
) => {
  console.log(
    "calculateTotalBill: ",
    selected_rooms_ids,
    all_rooms_info,
    totalDays,
  );

  let rooms = selected_rooms_ids;
  rooms = rooms.filter((room) => Object.keys(room).length > 0);

  let totalBase = 0;
  let totalGst = 0;
  let totalWithGst = 0;
  let totalBillAmount = 0;

  const roomBills = rooms.map((room) => {
    const bill = calculateBillAmountWithGST(
      parseFloat(room.room_price || room.room_amt),
      totalDays,
      0,
    );

    totalBase += bill.baseAmount;
    totalGst += bill.gstAmount;
    totalWithGst += bill.totalWithGst;

    return {
      room_id: room.id,
      room_no: room.room_no,
      ...bill,
    };
  });

  totalBillAmount = totalWithGst - advanceAmount;
  return {
    rooms: roomBills,
    summary: {
      totalBase: Number(totalBase.toFixed(2)),
      totalGst: Number(totalGst.toFixed(2)),
      totalWithGst: Number(totalWithGst.toFixed(2)),
      grandTotal: Number(totalBillAmount.toFixed(2)),
    },
  };
};

export const capitalizeWords = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
